import { defineQuery } from 'next-sanity';

export const getSupportSetting = defineQuery(`
  *[_type == "supportSetting"]{
  header,
  title,
  metaDescription,
  heroImage {
    ...,
    "imgAsset": asset-> {
      ...
    }
  },
  supporttitle,
  supporttext,
  supportButtonText,
  supportButtonLink,
  CSS, JS,
  supportBottomText[]{
    ...,
    markDefs[]{...,
      _type == "internalLink" => { 
      "slug": @.reference->slug.current,
       "type":@.reference->_type 
       }
    }
  }
}
`);

export const getSupportBlogBySlug = defineQuery(`
  *[_type == "faq" && slug.current == $slug][0]{
  _id,
  title,
  metaDescription,
  CSS, JS,
  category-> {
    title,
    slug,
    _id
  },
 content[]{
    ...,
    markDefs[]{...,
      _type == "internalLink" => { 
      "slug": @.reference->slug.current,
       "type":@.reference->_type     
       }
    },
    _type == "image" => {
      ...,
      asset-> {
        ...,
      }
    }
  },
  "text": pt::text(content),
}
`);

export const getAllFaqItemsCategoryWise = defineQuery(`
 *[_type == "supportCategory" && status == true] | order(title asc){
  title,
  icon,
  "faqData":*[_type == "faq" && references(^._id)] | order(coalesce(editedDate, _updatedAt) desc){
    title,
    "href":"/support/"+slug.current
  }
}
`);

export const getRelatedFaq = defineQuery(`
  *[_type == 'faq' && ($excludeIds == null || !(_id in $excludeIds)) && category._ref == $category]{
  title,
  slug,
  _id,
}
`);

export const getSupportListSeoData = defineQuery(`
  *[_type == "supportSetting"]{
  title,
  metaDescription,
}
`);

export const getSupportDetailSeoData = defineQuery(`
  *[_type == "faq" && slug.current == $slug][0]{
  title,
  metaDescription,
  slug,
  content
}
`);

export const faqSearchPage = defineQuery(`
  {
  "searchData": *[_type in ["faq"] && (title match $searchValue || pt::text(content) match $searchValue)] | order(_createdAt desc) {
    title,
    _type,
    _createdAt,
    slug,
    category->{
      title,
    },    
  },
  "total": count(*[_type in ["faq"] && (title match $searchValue || pt::text(content) match $searchValue)])
  }
`);

export const getAllFaqsSlugs = defineQuery(`
  *[_type == "faq" && defined(slug.current)][].slug.current`);
